import axios from "axios";

export const fetchPayment = async (data: any, dispatch: any) => {
    axios
        .post((process.env.REACT_APP_API_URL || '') + "/api/v1/cart/payment", data)
        .then((response) => response.data)
        .then((data: []) => {
            dispatch({
                type: "SET_PAYMENT",
                payment: data,
            });
        })
        .catch((e) => {
            console.log(e);
        })
};